export default {
  PENDING: 'isPending',
  DEFAULT: '',
};
